import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { setupStore } from "./store";
import { setupElementPlus } from "./plugins/element-plus";

import { versionChecker } from "./utils/versionCheck";

// 版本检查（异步处理）
if (versionChecker.checkVersion()) {
  versionChecker.showUpdateNotification().catch(error => {
    console.warn('版本更新提示显示失败:', error);
  });
}

import { message } from "./utils/message-manager";

message.setConfig({
  max: 3, // 最多同时显示3条
  grouping: true, // 相同内容分组
  debounceTime: 500, // 500毫秒内防重复
  showClose: false, // 显示关闭按钮
  defaultDuration: 3000, // 3秒后自动关闭
});

const app = createApp(App);

// 通过 provide/inject 提供（便于 Composition API 使用）
app.provide("$message", message);

import "@/assets/css/index.scss";

app.use(router);
setupStore(app);
setupElementPlus(app);

app.mount("#app");
